import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import moment from "moment"
import Title from "../general/title"
import getData from "helpers/submitData"
import { loadingStatus } from "actions"
import translate from "translations/global"
import Switch from "react-switch"
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"
import settings from 'settings'

class BuyerDetails extends Component {
	constructor(props) {
		super(props)
		this.state = {
			rows: [],
			filtered: [],
			sorted: [],
			pulling: "sale_date",
			columns: [
				{
					Header: "Property",
					accessor: "Community",
					filterMethod: (f, r) => helpers.tableText(f, r, "Community"),
				},
				{
					Header: "Bought Address",
					accessor: "Address",
					filterMethod: (f, r) => helpers.tableText(f, r, "Address"),
				},
				{
					Header: "Builder",
					accessor: "Builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "Builder"),
				},
				{
					Header: "Lot Type",
					accessor: "Lot Type",
					filterMethod: (f, r) => helpers.tableText(f, r, "Lot Type"),
				},
				{
					Header: "Neighborhood",
					accessor: "Neighborhood",
					filterMethod: (f, r) => helpers.tableText(f, r, "Neighborhood"),
				},
				{
					Header: "Buyer Address",
					accessor: "Buyer Address",
					filterMethod: (f, r) => helpers.tableText(f, r, "Buyer Address"),
				},
				{
					Header: "City",
					accessor: "Buyer City",
					filterMethod: (f, r) => helpers.tableText(f, r, "Buyer City"),
				},
				{
					Header: "Traffic Source",
					accessor: "Source",
					filterMethod: (f, r) => helpers.tableText(f, r, "Source"),
				},
				{
					Header: "Primary First",
					accessor: "Primary First",
					filterMethod: (f, r) => helpers.tableText(f, r, "Primary First"),
				},
				{
					Header: "Primary Last",
					accessor: "Primary Last",
					filterMethod: (f, r) => helpers.tableText(f, r, "Primary Last"),
				},
				{
					Header: "Co First",
					accessor: "Co First",
					filterMethod: (f, r) => helpers.tableText(f, r, "Co First"),
				},
				{
					Header: "Co Last",
					accessor: "Co Last",
					filterMethod: (f, r) => helpers.tableText(f, r, "Co Last"),
				},
				{
					Header: "Email",
					accessor: "Primary Email",
					filterMethod: (f, r) => helpers.tableText(f, r, "Primary Email"),
				},
				{
					Header: "Co Email",
					accessor: "Co Email",
					filterMethod: (f, r) => helpers.tableText(f, r, "Primary Email"),
				},
				{
					Header: "Primary Occupation",
					accessor: "Primary Occupation",
					filterMethod: (f, r) => helpers.tableText(f, r, "Primary Occupation"),
				},
				{
					Header: "Zip",
					accessor: "Buyer Zip",
				},
				{
					Header: "State",
					accessor: "Buyer State",
				},
				{
					Header: "Sale Date",
					accessor: "Sale Date",
					Cell: (v) => {
						return moment.unix(v.value).format("MM/DD/YY")
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
				},
				{
					Header: "Estimated Closing",
					accessor: "Estimated Closing",
					Cell: (v) => {
						if (!v.value) return ""
						return moment.unix(v.value).format("MM/DD/YY")
					},
				},
				{
					Header: "Closing Date",
					accessor: "Closing Date",
					filterMethod: (f, r) => helpers.tableText(f, r, "Closing Date"),
				},
				{
					Header: "Lot",
					accessor: "Lot",
					filterMethod: (f, r) => helpers.tableText(f, r, "Lot"),
				},
				{
					Header: "Block",
					accessor: "Block",
					filterMethod: (f, r) => helpers.tableText(f, r, "Block"),
				},
				{
					Header: "Section Name",
					accessor: "Section Name",
					filterMethod: (f, r) => helpers.tableText(f, r, "Section Name"),
				},
				{
					Header: "Input Date",
					accessor: "Input Date",
					Cell: (v) => {
						if (!v.value) return ""
						return moment.unix(v.value).format("MM/DD/YY")
					},
				},
			],
		}
		if (_.get(settings, `enabled.documentManagement`)) {
			this.state.columns.push({
				Header: "Buyer Profile",
				accessor: "Buyer Profile Date",
			})
		}
	}

	componentDidMount() {
		this.props.loadingStatus(true)
		this.pullData()
	}

	componentDidUpdate(prevProps) {
		if (prevProps !== this.props) {
			this.pullData()
		}
	}

	pullData = () => {
		getData("getBuyerDetails", { dates: this.props.currentDates, properties: this.props.activeProperties, type:this.state.pulling })
			.then((resp) => {
				this.setState({ rows: resp.data }, () => {
					//console.log(this.state)
				})
				this.props.loadingStatus(false)
			})
			.catch((e) => {
				console.log(e)
			})
	}

	countActions = (id) => {
		var count = 0
		this.props.payload.activity.forEach((r) => {
			if (id == r.user) {
				count++
			}
		})

		return count
	}

	buildTable = () => {
		let ret = []
		_.forEach(this.state.rows, (v) => {
			if (v.bustout_date) {
				return
			}
			let b = _.find(this.props.payload.public.builders, { id: v.builder })
			let property = _.find(this.props.payload.public.properties, { id: v.property })
			let lt = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let english = {
				builder: b ? b.name : "",
				lot_type: lt ? lt.name : "",
				sale_date: v.sale_date,
				property: property ? property.name : "",
				address: v.address,
				moving_address: v.buyer_address,
				source: v.traffic_source,
				buyer_city: v.buyer_city,
				primary_first: v.primary_first,
				primary_last: v.primary_last,
				co_first: v.co_first,
				co_last: v.co_last,
				email: v.primary_email,
				co_email: v.co_email,
				primary_occupation: v.primary_occupation,
				section_name: v.section_name,
				buyer_phone: v.buyer_phone,
				zip: v.buyer_zip,
				state: v.buyer_state,
			}

			let table = { ...v, ...english }
			let e = helpers.translateObject(table, translate)
			ret.push(e)
		})
		return ret
	}

	createTable = () => {
		return (
			<div className="content">
				<p className="mid infoNote pb-8" style={{ margin: 0 }}> <i className={`fas fa-info-circle`} /> Table includes sales (or closings if chosen) between the selected dates. Table excludes sales that cancelled at any time. </p>
				<div className="switch" style={{ marginBottom: 40 }}>
					<p>Viewing {(this.state.pulling == "sale_date" && "Sales") || "Closings"}</p>
					<Switch
						onChange={this.toggle}
						checked={this.state.pulling == "sale_date" ? false : true}
						checkedIcon={false}
						uncheckedIcon={false}
					/>
				</div>
				<FullTable
					data={this.buildTable()}
					columns={this.state.columns}
					classNames={`small`}
					pageSize={20}
					name="buyerDetails"
					title="Buyer Details"
				/>
			</div>
		)
	}

	toggle = () => {
		if(this.state.pulling == 'sale_date') {
			this.setState({pulling: 'closing_date'}, () => {
				this.pullData()
			})
		}
		else {
			this.setState({pulling: 'sale_date'}, () => {
				this.pullData()
			})
		}
	}

	render() {
		return (
			<div className="sales">
				<div className="imageGroup">
					<Title title="Buyer Details" />
					{this.createTable()}
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(BuyerDetails)
